import { useMemo } from "react";

import { useGetWorkplaceAgreements } from "./useGetWorkplaceAgreements";

export function useGetLatestWorkplaceAgreement(
  workplaceId: string | undefined,
  options?: { include?: Array<"document"> }
) {
  const query = useGetWorkplaceAgreements(workplaceId, options);

  const latestAgreement = useMemo(
    () =>
      query.data?.data
        ?.slice()
        .sort(
          (a, b) =>
            new Date(b.attributes.acceptedAt).getTime() -
            new Date(a.attributes.acceptedAt).getTime()
        )[0],
    [query.data?.data]
  );

  return {
    ...query,
    latestAgreement,
  };
}
